import _ from "lodash-uuid";
import moment from "moment";
import {DateTime} from "luxon";

export function parseData(data) {
  if (!data) return [];
  return data["edges"].map((e) => e["node"]);
}

export function decodeId(id) {
  if(typeof(id) == 'string'){
    if (/^\d+$/.test(id)) return id;
    else return atob(id).split(":")[1];
  }
  else{
    return atob(id.id).split(":")[1];
  }
}

export function apiHeaders() {
  let headers = {
    "Content-Type": "application/json",
  };
  return headers;
}

export function formatGQLString(str) {
  if (!str) return str;
  return str
    .replace(/[\"]/g, '\\"')
    .replace(/[\\]/g, "\\\\")
    .replace(/[\/]/g, "\\/")
    .replace(/[\b]/g, "\\b")
    .replace(/[\f]/g, "\\f")
    .replace(/[\n]/g, "\\n")
    .replace(/[\r]/g, "\\r")
    .replace(/[\t]/g, "\\t");
}

export function pageInfo(data) {
  if (!data) return {};
  return {totalCount: data["totalCount"], ...data["pageInfo"]};
}

export function formatMutation(
  operationName,
  input,
  clientMutationLabel,
  clientMutationDetails
) {
  const clientMutationId = _.uuid();
  const payload = `
    mutation {
      ${operationName}(
        input: {
          clientMutationId: "${clientMutationId}"
          clientMutationLabel: "${clientMutationLabel}"
          ${
    !!clientMutationDetails
      ? `clientMutationDetails: ${JSON.stringify(
        clientMutationDetails
      )}`
      : ""
  }
          ${input.trim()}
        }
      ) {
        clientMutationId
        internalId
      }
    }`;
  return {clientMutationId, payload};
}

function _entityAndFilters(entity, filters) {
  return `${entity}${
    !!filters && filters.length ? `(${filters.join(",")})` : ""
  }`;
}

function _pageAndEdges(projections) {
  return `
    pageInfo { hasNextPage, hasPreviousPage, startCursor, endCursor}
    edges
    {
      node
      {
        ${projections.join(",")}
      }
    }`;
}

export function formatPageQuery(entity, filters, projections) {
  return `
    {
      ${_entityAndFilters(entity, filters)}
      {
        ${_pageAndEdges(projections)}
      }
    }`;
}

export function formatPageQueryWithCount(entity, filters, projections) {
  return `
    {
      ${_entityAndFilters(entity, filters)}
      {
        totalCount
        ${_pageAndEdges(projections)}
      }
    }`;
}

export function formatServerError(payload) {
  return {
    code: payload.status,
    message: payload.statusText,
    detail:
      !!payload.response && payload.response.errors
        ? payload.response.errors.map((e) => e.message).join("; ")
        : null,
  };
}

export function formatGraphQLError(payload) {
  return !payload.errors
    ? null
    : {
      code: "Data error",
      message: "Server returned data error status",
      detail: payload.errors.map((e) => e.message).join("; "),
    };
}

export function formatDateFromISO(dateString) {
  return moment(dateString).format("YYYY-MM-DD");
}

export function formatDateForFr(dateString) {
  return moment(dateString).format("DD-MM-YYYY");
}

export function formatDate(
  dateString,
  format = "dd/MM/yyyy HH:mm",
) {
  if (!dateString) {
    return "";
  }

  const date = DateTime.fromISO(dateString, {zone: "utc"}).setZone(
    DateTime.local().zoneName,
  );

  return date.setLocale("fr").toFormat(format);
}

export function formatNumber(number) {
  let numberToParse = number
  if (typeof number === "string") {
    numberToParse = parseInt(number, 10)
    if (isNaN(numberToParse)) {
      return number
    }
  }

  return new Intl.NumberFormat().format(numberToParse);
}

export const data = [
  {
    value: "1",
    label: "Request for information",
  },
  {
    value: "2",
    label: "Draft",
  },
  {
    value: "3",
    label: "Offer",
  },
  {
    value: "4",
    label: "Negotiable",
  },
  {
    value: "5",
    label: "Executable",
  },
  {
    value: "6",
    label: "Addendum",
  },
  {
    value: "7",
    label: "Effective",
  },
  {
    value: "8",
    label: "Executed",
  },
  {
    value: "9",
    label: "Disputed",
  },
  {
    value: "10",
    label: "Terminated",
  },
  {
    value: "11",
    label: "Counter",
  },
];

export const getValueLabel = (value) => {
  const item = data.find((item) => item.value == value);
  return item ? item.label : "";
};

export const getPolicyholderId = localStorage.getItem("policyholderId");
